import React, {useState, useEffect} from 'react'
import { useParams } from "react-router-dom";
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {sortBy} from 'lodash'
import * as _ from 'immutable'
import config from 'config'
import jwtDecode from 'jwt-decode'
import {css, StyleSheet} from 'aphrodite/no-important'
import {getAccessToken, getDomains} from '../selectors'
import Loading from '../components/elements/loading'
import DatePicker from "react-datepicker";
import kibanaImg from "./kibana.svg";

import "react-datepicker/dist/react-datepicker.css";

const imgPlaceholder = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAe1BMVEVVYIDn7O3///9TXn9KVnnq7+/t8vJGU3dNWXtRXH1EUXbe4+ZJVXlPWnzp7u+/xc5faYdZZIP29vhsdZBye5SFjKJocY3DydG1u8aytsN+hp2an7Hi5+nl5uvz9PaTmazR09vU2t+kqbmMk6efprXO1NrZ2+Kssr/h4ujU+9XeAAAMKklEQVR4nN2d6ZKjOgxGHWywTbMkZN/3Tr//E46BLCSBAJII1Hx169bM/KA5LSPJsmwzq3FF6104PyyPo+Gk3x8wxgb9yWhxXM7D3d+m+R/Pmnz4X3gYT5iQQihfa84ZM/+x+P+ca18JISWbjA/hX5Mv0RThOlwOXSmUTpmKxbUS0u1vZ+uG3qQJwr/5gkvhl7E9cfpC8sW8CWNSE26mRy2VrgH3kFYu304j4jciJdzMRkLA6O6UwhvNSP0PIWG4cJF4N0i5COlei4rw9yg8Crw75PiX6M1oCGd9Weo0a8qXkxnJuxEQrreuIMZLxIVcBh0g/F24fgN4KaOSY3QAQRL+jly6ry9PvjtCfpAowt+RbJYvlpYjlB0RhOtFw/a7M7pjREoHJtwcv8QXy3e34FQHSnjxGvMvuVJi/lXCHWskPnyU14e5HAhhNHa/zmfE3e2XCMMvD9CHFN99gTAay5b4GMyMdQl3ui0DplKs7tdYk3DptsrHYjMeGiTcTETbgEZiVCs21iGckkxw8fL9Og6nBuGp9RF6l3tpgnDUhRF6kxyTE2767frQV6lJ1XJVRcI/wiIMjbSuON+oRrhrMcoXictqkbES4byVPLRU7pSK8NAdJ/ok7lYpq1YgXHZwiF7lVpg0lhNuPcp34ox0wFdALCUkAORcKyWEJ6Xr+dr3XCk9IZRKVhQbRywjRANq5fn98Wkenvc/PSdV72d/Duen8cQXwGWqDGJZZbyEEOdkuJJ6fDmvDJRtB3bQu8n82bbNv67Ol7GWCmXKMnfzmfCCAOTKGx72hi14kL0qCAzn/jD0MJAlQeMjYQgH5KJv8Gy7EO6hBLLvgRm5+zH0fyLcgQG5NwqN9Srg3SHDITyzFz0Y4RocB1U/dIqHZsGAdWYDBfx5fAAijAbAccO9U6XR+WbIYAkdqnoEIRwC/bia7B0AX2LGcx9oRlFcgysk3AI/C3n84DtLzdgbA+OvLAyLRYRQN+pdan+Bz2Y8ARHdoiW4AsK1hH0R7gw4Qu9ygDGYF9mq4N+BXkaiAWNEmBX9RR3CI+yDFyc8oEEEugCZn4TnEk5hA8VfUAAaRKAbz/8U8wg3wI9drzBO5qHgB7Y6yftVCRewwqFH8BGmci6wcSqW1QhDWLamR1SAJi72ga48Jwd/J4yAgUKeacZorCCEGTEvQX0nXACbQ4ncTCpnAvs1i1M5IbT4600h2XaR7Bk0aXyrhL8RAvNt3qcE7AU9slnGK+EJmNz7JMH+IecIXAmSrzWNF8IedFrvEfqZWDbQ17znpy9/B4ZCY0NaE5phCv1di8snwl9o4UKPiQlN6gYtMYjNB0LoU5m6kDqamHALrRX722JCYMZtJEhjRSx7Dq1LMTcoJATmSkbenpxwCq4u6mMRITAhZfGmHqJpRYZwD18xeQr7WUK4CRkj5ounUHBC/5hPiFmsH1CbsBesEM0f7iaXEOxIY1EDGiHeRi3zCMGxMBH5dxisMK+johxC4KwpUQOeJliBo4VRpiv8TrhBrYWqH3LCH1SXGX8nhE4qOkood2+EmMd1kFAvXgmnuI6EzhE+Urcb4QjXE9E9QnV5JsT5mS4S3stuV8ILys90kZDdWhevhMDiXZcJb9PElHCN7T7sICHTWcIDcpB2kvAaElNCzLyps4TXYZoQwjtnukzI2INwjn5YJwnl350QGe67SpgG/YQQ3+bcScJ0DSMm3OHbgDtJyNzoSoibOHWYUOyuhNiEprOE6pQSQlsvuk/IJykhxZafjhKKKCFEp2xGogFCgqEVzy8Yrsh2FVcN1NoI9juqeUKINyEXZ+qFmV7PPsOb22+Ky/vMCvD7tgRZN1RWDrQf46G4D4xZO3zuQNpKk0EcoY3oxoTYAgZtN1RWNrIAyJLkm1lHrKPhk2ZMaIyInreK0BCilpxi+cvGCMFr+TepgyFEj3U1o3ekqWz0F+SPLbZBZzQibOYzhLcoPmTyNvZHQNiYDdGEjFkMPznsNKGIGD6sdppQrhk+7+40offLlui8u9OEYsfG/znhjOFzv04TqgubYJ/RbUL/wAb/N6Feovk6Tuhv/3dCPf7fCfnivycc/e+ErP/fE1Koy/PDWPh4qObdnePHfOhiD9Pbxuo00M1PGfUJsjbeb4wQP8AMH7rURr318KEAvuXiLj4kmFuYmNNQzZvgt28iPn5+mByG0QQgcEf3k/SRbSnOtJRTekRnSnESnplbnEhO7fSoEQMnJFi4TeaHBCEnlksaFANndQRumn+RmjOixIjyvIFe8LNVRAfCiinDLx8mIt1T4mzJju0XO4Kq/vVRhEHRpnmlWHJNsDKTyqfL3RCbK98kIoLVtasGZIQU6ehdFqPo+UokqNa6gxXd5Rl8aAgpkppYZEvBNr6h9y59NIQULVGJqPaRQs81yZO6GEKySgHRFIOgA+MhsTOE+Db2q4jOVXAIutDuctdx1xfZWdYk7Xv2nvBsbe4lfW0Es7BUiuIEFwfd35NR3OltCJdk0YfjbQg9ySxfcZOwIaQrSgr8BIM02hvnlxCSuRrG+1gj2j+kJ9zLIO1kp3uiwLZHOWPSazQG1159uqfyAY4wOJOe4Z8cchIT4ltq7hK4mhRFdS37NuGVEL2/MivMRJigK/hJyX7uZN8TQWn5JoXIv4MV7VUv6VmYCSFJRfEqdw82IrGbMbOdOyHB1q674CUpG37GUb7SbbIJYUSZR4g5DBF3XEueVGYfMGU6z8UPKGRQj9HbgVgpIelqMmycOoQz+1RimiGMSL8ASFAM9jQ17ozU05kKlMMUcnpbsILeU1Co26ltV0LCCiWLA1FdEzr4zdavup3Bczu9hfb229pB0aG/1s23ngkpg775/dWtZzjk156p0wsh1fJFqg4QuusXQrLSd6L2CR/nCd8JSdP69glF+EZoUd4A2AFC651wSVXdZx0gVIccQrqCVPuE3NvkEBKWa1onzB4lnCH8oytmtE2YPUk4ewYtXebUMqHO3hacJcSdYJpVy4SF5wjTGbFdwuKzoOm+xHYJ3V4hIZk7lXWrphS9sjd9OpOdLCbWXmYjLHZz+elcfaLEpn6lhnBRLZPO5BFGJITqULeKAb515V3c+khIM8Xwate9gx/chbIPyderZd/umSGYJ/qApgyqaqkevgK9EeIjBheAixLsPY2Tq3BXEN7ZSNAaonOi+D6q3PdkWRo3Tr0jbN3CWRAc51Tpzi7ENcCxJBCwFwRDNGK1e9csawv/SVrBl7mD4IispOSM0YIbHqF32Gsx/kGs4wdO2MdUpqvff2j9gsYpl6Mz6iJZ41HtGeKC7nc/WkhoQS47FZMpki9hdMCMde4hNTPFuvFXsBkBX8JozwYQxnp3yVpRPUKlD6CruAsYIXasex9wrZChveWKdttT/D3W9Dl173S2rHnVLEpL40DJ9zrXtaP7mnCXE1a89Zh7aAdaxFjHjrm3yJYRWsPyb5HTONAPjNXsqAq8TAlhxMueLgYzp6md6nfGCnbUuaG+nNBaf4yKXPmXoFG+hDGYDcoYud58oPhEaHKb4mdrsew1tUv9mdEps2N+LlOJsPhCRO0eG3CgRYwf7cjd3UeGz4RWmIvI5WL/Nb6E8YMdSwDLCK35O2KzDrSIsciOxYGwIqE1e0UU/YYdaBGjM8+xYylgOeGLFZX+ggMtYgzexqo7K33/csKsFbV3Is5AazI+x0debsFKhMbdpA/l3hcdaBFjbMeqTqYy4TVoiElDGWhNRvui/dSj59SdgITWrxkactmKg8mRsxpLzrT+GOhrElrBQIZtfoDPCpyZpwafUrX6hFZEfqUxSs5+EZW/dC1Cy+oUYc+p/N7VCa1N21QZVRyhNQmtqG2uu6qO0LqExuG0jZYoKH9RMGEnRmqNEQog7MBIrTNCIYSW1W5YrO5D4YStmrGuAWGE7ZmxvgGhhFbUhlOt50KRhG041ZouFE347aEKGqBIwm9mqjbiLTGE32IEfoAkhN/I4zD2oyBs+nuEf390hE0yQv1nVhSEJnY0MVgDQAKTIxpCi96Q+OF5FRmhSXToPKtDY75EhIQWUTZnE+JZ1IRGEW64UlovFTlhrA2ww5TCdb6pEcJYUS3/GtDb7qbGCBNFm9KVjsDZNAaXqFnCq6LNxnFsOwgS3MD8wXaczSZqFu2qf0bEBYdvuOiJAAAAAElFTkSuQmCC'

const statusColors =  ["#d4159e", "#aaaaaa", "#aaaaaa", "#4b6e99", "#ff0000", "#ffff00", "#00ff00"]

const styles = StyleSheet.create({
  devicesListContainer: {
    margin: 10,
    background: '#fff',
    padding: 20,
    boxShadow: '2px 2px 3px #ccc',
    fontSize: 14,
  },
  tokenInput: {
    width: '100%',
    boxShadow: '3px 3px 3px inset #00000017',
    background: '#fbfbfb',
    border: '1px solid #ccc',
    borderRadius: '3px',
    fontSize: 16,
  },
  userItem: {

  },
  userAvatar: {
    display: 'inline-block',
    height: 50,
    width: 50,
    backgroundSize: 50,
    borderRadius: '50%',
    overflow: 'hidden'
  },
  userName: {
    display: 'inline-block',
    marginLeft: 10,
    transform: 'translateY(-75%)',
  },
  list: {
    listStyle: 'none',
    padding: '10px 20px',
  },
  listItem: {
    display: 'flex',
    margin: 10,
    paddingBottom: 5,
    paddingTop: 5,
    borderBottom: '1px solid rgba(0,0,0,0.1)',
    cursor: 'pointer'
  },
  listItemImage: {
    float:'right',
    borderRadius: '0%',
    width: 50,
    height: 50,
    transform: 'translateY(10px)',
  },
  box: {
    float: 'left',
    height: '20px',
    width: '120px',
    marginottom: '15px',
    clear: 'both',
  },
  statusListContent: {
    borderRadius: '50%',
    width: 120,
    height: 100,
    transform: 'translateY(10px)'
  },
  listItemContent: {
    marginLeft: 40,
    minWidth: 300,
    flex: 1,
    fontSize: 14,
  },
  listItemContentH4: {
    margin: 0,
    marginTop: 10,
    fontSize: 16
  },
  listItemContentRole: {
    margin: 0,
    marginTop: 5,
    marginRight: 5,
    fontSize: 14,
    background: '#fff',
    border: '2px solid rgb(75, 110, 153)',
    color: 'rgb(75, 110, 153)',
    fontWeight: '700',
    padding: '2px 10px',
    textAlign: 'center',
    display: 'inline-block',
    borderRadius: 5,
  },
  availableRoles: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '10px auto',
  },
  availableRole: {
    margin: 0,
    marginTop: 5,
    marginRight: 5,
    fontSize: 14,
    // background: 'rgb(75, 110, 153)',
    background: '#fff',
    border: '2px solid rgb(75, 110, 153)',
    color: 'rgb(75, 110, 153)',
    fontWeight: '700',
    padding: '2px 10px',
    textAlign: 'center',
    display: 'inline-block',
    borderRadius: 5,
    cursor: 'pointer',
  },
  listItemContentP: {
    margin: 0,
    marginTop: 5,
    color: '#aaa',
    fontSize: 14,
    lineHeight: '24px',
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "300px"
  },
  devicesListPager: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '10px 0',
  },
  devicesActionBar: {
    float:'right',
    margin: '0 auto',
    marginRight: 5,
  },
  deviceExportButton: {
    float:'right',
    margin: '0 auto',
    marginTop: 5,
    marginRight: 5,
    fontSize: 14,
    // background: 'rgb(75, 110, 153)',
    background: '#fff',
    border: '2px solid rgb(75, 110, 153)',
    color: 'rgb(255, 40, 40)',
    fontWeight: '700',
    padding: '2px 10px',
    textAlign: 'center',
    borderRadius: 5,
    cursor: 'pointer',
  },
  deviceActionBar: {
    paddingBottom: '25px'
  },
  editCommentArea: {
    display: 'none',
    float: 'top',
    width: '500px',
    marginTop: '30px',
    background: '#fff',
    color: 'rgb(75, 110, 153)',
    borderRadius: '3px',
    padding: '0px 7px',
    paddingTop: '20px',
    paddingLeft: '15px',
    paddingBottom: '5px',
    cursor: 'pointer',
    boxShadow: '2px 2px 3px #ccc',

  },
  editCommentText: {
    marginTop: '-10px',
    width: '470px'
  },
  editCommentAllArea: {
    float: 'bottom',
    maxWidth: '100%',
    color: 'rgb(75, 110, 153)',
    background: '#fff',
    cursor: 'pointer',
  },
  editCommentAllText: {
    float: 'center',
    boxShadow: '2px 2px 3px #ccc',
    marginTop: '10px',
    marginBottom: '5px',
    marginLeft: '5px',
    marginRight: '5px'
  },
  editConfirmButton: {
    float: 'bottom',
    margin: '0',
    marginTop: 5,
    marginBottom: 5,
    marginRight: 5,
    fontSize: 14,
    // background: 'rgb(75, 110, 153)',
    color: 'rgb(75, 110, 153)',
    fontWeight: '700',
    padding: '2px 10px',
    textAlign: 'center',
    cursor: 'pointer',
  },
  deviceRebootButton: {
    float:'right',
    margin: '0',
    marginTop: 5,
    marginBottom: 25,
    marginRight: 5,
    fontSize: 14,
    // background: 'rgb(75, 110, 153)',
    background: '#fff',
    border: '2px solid rgb(75, 110, 153)',
    color: 'rgb(255, 40, 40)',
    fontWeight: '700',
    padding: '2px 10px',
    textAlign: 'center',
    borderRadius: 5,
    cursor: 'pointer',
  },
  deviceStatusButton: {
    float:'left',
    margin: '0',
    marginTop: 5,
    marginBottom: 25,
    marginRight: 5,
    fontSize: 14,
    // background: 'rgb(75, 110, 153)',
    background: '#fff',
    border: '2px solid rgb(75, 110, 153)',
    color: 'rgb(75, 110, 153)',
    fontWeight: '700',
    padding: '2px 10px',
    textAlign: 'center',
    borderRadius: 5,
    cursor: 'pointer',
  },
  confirmButton: {
    float: 'botom',
    margin: '0',
    marginTop: 5,
    marginBottom: 5,
    marginRight: 5,
    fontSize: 14,
    // background: 'rgb(75, 110, 153)',
    color: 'rgb(75, 110, 153)',
    fontWeight: '700',
    padding: '2px 10px',
    textAlign: 'center',
    cursor: 'pointer',
  },
  devicesListPageChanger: {
    textAlign: 'center',
    background: '#fff',
    border: '2px solid rgb(75, 110, 153)',
    color: 'rgb(75, 110, 153)',
    borderRadius: '3px',
    margin: '2px 2px',
    padding: '0 7px',
    cursor: 'pointer',
  },
  devicesListPageNumbers: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  devicesListPageNumber: {
    textAlign: 'center',
    background: '#fff',
    border: '2px solid rgb(75, 110, 153)',
    color: 'rgb(75, 110, 153)',
    borderRadius: '3px',
    margin: '2px 2px',
    padding: '0 7px',
    cursor: 'pointer',
  },
  devicesListPageCount: {
    textAlign: 'center',
  },
  accessDenied: {
    textAlign: 'center',
    padding: 20,
    fontSize: '24px',
    color: '#d26363',
    fontWeight: '700',
  },
  overlay: {
    height: "100%",
    width: "100%",
    position: "fixed", 
    zIndex: 100, 
    left: 0,
    top: 0,
    backgroundColor: "rgb(0,0,0)", 
    backgroundColor: "rgba(0,0,0, 0.4)", 
    overflowX: "hidden",
    transition: "0.5s"
  },
  leftButton: {
    float: 'left',
    position: 'relative'
  },
  overlayContent: {
    position: "relative",
    top: "25%",
    margin: "0 auto",
    width: "20%",
    background: '#fff',
    whiteSpace: "pre-wrap",
    border: '2px solid rgb(75, 110, 153)',
    color: 'rgb(75, 110, 153)',
    borderRadius: '3px',
    padding: '0 7px',
    paddingTop: '10px'
  },
  overlayButton: {
    display:"inline-block",
    marginTop: 15,
    marginRight: 10,
    marginLeft: 10,
    marginBottom: 10,
    fontSize: 14,
    // background: 'rgb(75, 110, 153)',
    background: '#fff',
    border: '2px solid rgb(75, 110, 153)',
    color: 'rgb(255, 40, 40)',
    fontWeight: '700',
    padding: '2px 10px',
    textAlign: 'center',
    borderRadius: 5,
    cursor: 'pointer',
  }, 
  deviceConfigKey: {
    fontWeight: '700',
    marginRight: '10px'
  },
  deviceConfigValue: {}
})

const styles2 = StyleSheet.create({
  deviceContainer: {
    position: 'fixed',
    top: 150, left: 150, right: 150, bottom: 150,
    overflowY: 'scroll',
    background: '#f3f3f3',
    padding: 20,
    boxShadow: '2px 2px 3px #ccc',
    border: '1px solid #ccc',
    borderRadious: '3px',
  },
  listItemContentRole: {
    margin: 0,
    marginTop: 5,
    marginRight: 5,
    fontSize: 16,
    background: '#fff',
    border: '2px solid rgb(75, 110, 153)',
    color: 'rgb(75, 110, 153)',
    fontWeight: '700',
    padding: '2px 10px',
    textAlign: 'center',
    display: 'block',
    borderRadius: 5,
  },
  roleEditor: {
    display: 'flex'
  },
  rolebox: {
    flex: '1'
  },
  deviceJson: {
    fontFamily: 'monospace',
    background: '#fff',
    padding: 15,
    marginTop: '20px',
    marginBottom: '20px',
    border: '1px solid #ddd'
  },
  editDeviceJson: {
    fontFamily: 'monospace',
    background: '#fff',
    padding: 5,
    border: '1px solid #ddd'
  },
  button: {
    margin: 0,
    marginTop: 5,
    marginRight: 5,
    fontSize: 16,
    background: 'rgb(75, 110, 153)',
    border: '2px solid rgb(75, 110, 153)',
    color: '#fff',
    fontWeight: '700',
    padding: '2px 10px',
    textAlign: 'center',
    display: 'inline-block',
    borderRadius: 5,
    cursor: 'pointer',
  },
})

function getQuery(domainId, deviceType) {
  switch(deviceType) {
    case 'floorplan':
      return `query devicesData {
              devices(domainId:"${domainId}", deviceType:"${deviceType}"){
                devices{
                  id
                  name
                  description
                  deviceType
                  hardwareId
                  deviceConfig{
                    id
                    building {
                      name
                      id
                    }
                    floor {
                      name
                      id
                    }
                    timezone
                    screenRotation
                    screenResolution
                    screenOnTime
                    screenOffTime
                    configPollInterval
                    rebootTime
                    dnsNameservers
                    proxyAddress
                    environment
                    floorplanConfig{
                      floorplanId
                    }
                    gatewayConfig{
                      gatewayId
                      band
                      frequency
                      x
                      y
                    }
                  }
                }
              }
            }
          `
    case 'sensor':
      return `query devicesData {
              devices(domainId:"${domainId}", deviceType:"${deviceType}"){
                devices{
                  id
                  name
                  description
                  deviceType
                  hardwareId
                  deviceConfig{
                    id
                    building {
                      name
                      id
                    }
                    floor {
                      name
                      id
                    }
                    sensorConfig{
                      type
                      room{
                        name
                        id
                      }
                      seat{
                        id
                        internalId
                        name
                      }
                      edgeId
                      address
                    }
                  }
                }
              }
            }
          `
    case 'tablet':
      return `query devicesData {
              devices(domainId:"${domainId}", deviceType:"${deviceType}"){
                devices{
                  id
                  name
                  description
                  deviceType
                  hardwareId
                  deviceConfig{
                    id
                    building {
                      name
                      id
                    }
                    floor {
                      name
                      id
                    }
                    tabletConfig{
                      room{
                        id
                        name
                      }
                    }
                  }
                }
              }
            }
          `
    case 'beacon':
    return `query devicesData {
              devices(domainId:"${domainId}", deviceType:"${deviceType}"){
                devices{
                  id
                  name
                  description
                  deviceType
                  hardwareId
                  deviceConfig{
                    id
                    building {
                      name
                      id
                    }
                    floor {
                      name
                      id
                    }
                    beaconConfig{
                      typeName
                      macAddress
                      major
                      minor
                      x
                      y
                    }
                  }
                }
              }
            }
          `
    case 'external':
      return `query devicesData {
              devices(domainId:"${domainId}", deviceType:"${deviceType}") {
                devices {
                  id
                  name
                  description
                  deviceType
                  hardwareId
                  deviceConfig {
                    id
                    building {
                      name
                      id
                    }
                    floor {
                      name
                      id
                    }
                    externalConfig {
                      vendorId
                      modelName
                      resource {
                        id
                        name
                      }
                    }
                  }
                }
              }
            }
          `
  }
}

function intersect(a, b) {
  return a.filter(Set.prototype.has, new Set(b))
}

function placeCaretAtEnd(el) {
    el.focus();
    if (typeof window.getSelection != "undefined" && typeof document.createRange != "undefined") {
        var range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(false);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (typeof document.body.createTextRange != "undefined") {
        var textRange = document.body.createTextRange();
        textRange.moveToElementText(el);
        textRange.collapse(false);
        textRange.select();
    }
}

const createArray = (size) => {
  const _array = []
  for (let i = 0; i < size; i += 1) {
    _array[i] = i
  }
  return _array
}

const removeEmpty = (obj) => {
  Object.entries(obj).forEach(([key, val])  =>
    (val && typeof val === 'object') && removeEmpty(val) ||
    (val === null || val === "") && delete obj[key]
  );
  return obj;
};

const fetchDevicesList = (accessToken, domainId, deviceType) => {
  var queryDeviceType;
  if (deviceType == 'Beacon') {
    queryDeviceType = 'beacon';
  } else if (deviceType == 'Edge' || deviceType == 'Floorplan') {
    queryDeviceType = 'floorplan';
  } else if (deviceType == 'Sensor') {
    queryDeviceType = 'sensor';
  } else if (deviceType == 'Tablet') {
    queryDeviceType = 'tablet';
  } else if (deviceType == 'External') {
    queryDeviceType = 'external';
  }
  return fetch(
      `${config.GRAPHQL}`,
      {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
          query: getQuery(domainId, queryDeviceType),
        }),
      },
    )
      .then((r) => r.json())
      //.then(rejectOnGraphqlErrors)
      .then((r) => {
        r = r.data.devices.devices;
        r = r.filter(d => deviceType !=  'Floorplan'  || (deviceType ==  'Floorplan' && d.deviceConfig && d.deviceConfig.floorplanUrl && d.deviceConfig.floorplanUrl.includes('d=live')));
        r.map(d => {
          var location = "";
          if (!d.hardwareId &&  d.deviceType !=  'floorplan') {

            if (d.description) {
              location = d.description;
              
            }
            d.location = location;
            d.status = -1;
            d.statusText = 'unassigned';
            d.lastSeen = 'unknown';
            return d;
          }
          else if (!d.deviceConfig) {
            if (d.description) {
              location = d.description;
              
            }
            d.location = location;
            d.status = -1;
            d.statusText = 'unknown';
            d.lastSeen = 'unknown';
            return d;
          }
          d.deviceConfig = removeEmpty(d.deviceConfig)
          if (d.deviceConfig.building && d.deviceConfig.building.name) {
            location += d.deviceConfig.building.name;
          }
          if (d.deviceConfig.floor && d.deviceConfig.floor.name) {
            if (location != "") {
              location += " - ";
            }
            location += d.deviceConfig.floor.name;
          }
          if (queryDeviceType == 'sensor') {
            if (d.deviceConfig.sensorConfig && d.deviceConfig.sensorConfig.room && d.deviceConfig.sensorConfig.room.name) {
              if (location != "") {
                location += " - ";
              }
              location += d.deviceConfig.sensorConfig.room.name;
            } else if (d.deviceConfig.sensorConfig && d.deviceConfig.sensorConfig.seat && (d.deviceConfig.sensorConfig.seat.internalId || d.deviceConfig.sensorConfig.seat.name)) {
              if (location != "") {
                location += " - ";
              }
              if (d.deviceConfig.sensorConfig.seat.name) {
                location += d.deviceConfig.sensorConfig.seat.name;
              } else {
                location += d.deviceConfig.sensorConfig.seat.internalId;
              }
            } 
            if (d.deviceConfig.sensorConfig && d.deviceConfig.sensorConfig.type) {
              if (location != "") {
                location += " - ";
              }
              location += d.deviceConfig.sensorConfig.type;
            }
          }

          if (queryDeviceType == 'tablet') {
            if (d.deviceConfig.tabletConfig && d.deviceConfig.tabletConfig.room && d.deviceConfig.tabletConfig.room.name) {
              if (location != "") {
                location += " - ";
              }
              location += d.deviceConfig.tabletConfig.room.name;
            } else if (d.deviceConfig.tabletConfig && d.deviceConfig.tabletConfig.seat && d.deviceConfig.tabletConfig.seat.internalId) {
              if (location != "") {
                location += " - ";
              }
              location += d.deviceConfig.tabletConfig.seat.internalId;
            }
          }
          if (queryDeviceType == 'beacon') {
            if (d.deviceConfig.beaconConfig && d.deviceConfig.beaconConfig.typeName) {
              if (location != "") {
                location += " - ";
              }
              location += d.deviceConfig.beaconConfig.typeName + ' - ' + d.deviceConfig.beaconConfig.major + ' - ' + d.deviceConfig.beaconConfig.minor;
            }
          }
          if (queryDeviceType == 'external') {
            if (d.deviceConfig.externalConfig && d.deviceConfig.externalConfig.vendorId) {
              if (location != "") {
                location += " - ";
              }
              location += d.deviceConfig.externalConfig.vendorId + ' - ' + d.deviceConfig.externalConfig.modelName;
            }
          }
          d.location = location;
          d.status = 0;
          d.statusText = 'unknown';
          d.lastSeen = 'unknown';
          return d
        });
        return r;
      })
}

const fetchDeviceStatusMap = (accessToken, domainId, deviceType) => {
  const url = new URL(`${config.API_URL}/healthstatuses`)
  const searchParams = new URLSearchParams({domainId, resourceType:deviceType.toLowerCase()});
  url.search = searchParams

  return fetch(
    url,
    {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      method: 'GET',
    },
  ).then((response) => {
    var r = response.json()
    return r
  }).catch((e) => {
    console.log(e);
    return []
  }) 
}

const handleReboot = async (accessToken, deviceId) => {
  await fetch(
      `${config.DEVICE_ACTIONS}`,
      {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
        method: 'PUT',
        body: JSON.stringify({deviceId, actionType: 'reboot'})
      })
}

const handleDeleteConfig = async (accessToken, deviceId) => {
  await fetch(
    `${config.GRAPHQL}`,
    {
      headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
      },
    method: 'POST',
    body: JSON.stringify({
          query: `mutation{unassignAndUnpublishDeviceConfig(id:"${deviceId}"){id}}`,
    }),
  }).catch((e) => {
    console.log(e)
  })
}

const handleUpdateDevice = async (accessToken, deviceId, deviceConfig) => {
  var configUpdate = JSON.stringify(deviceConfig).replaceAll('"','').replaceAll('\\\\', '"')
  console.log(`mutation{updateAndPublishConfigForDevice(deviceId:"${deviceId}", deviceConfig:${configUpdate}){id}}`)
  await fetch(
    `${config.GRAPHQL}`,
    {
      headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
      },
    method: 'POST',
    body: JSON.stringify({
          query: `mutation{updateAndPublishConfigForDevice(deviceId:"${deviceId}", deviceConfig:${configUpdate}){id}}`,
    }),
  }).catch((e) => {
    console.log(e)
  })
}

const handleUnassign = async (accessToken, deviceId) => {
  await fetch(
    `${config.AUTH_URL}/auth`,
    {
      headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
      },
    method: 'POST',
    body: JSON.stringify({
          response_type: 'unassign_device_id',
          device_id: `${deviceId}`
    }),
  }).catch((e) => {
    console.log(e)
  })
}

const noop = () => {
  return false
}

function uppercasefirst(string) 
{
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function RebootOverlay(props) {
  const {devices, token, handleClose} = props
  const [thisDevices, setThisDevices] = useState(devices)
  const [accessToken, setToken] = useState(token)

  function handleCancel() {
    handleClose()
  }

  async function handleConfirm() {
    Promise.all(thisDevices.map(d => handleReboot(accessToken, d.id)))
    handleClose()
  }

  if (!thisDevices || thisDevices.filter(d => d.resourceId).map(d => {return {resourceId: d.resourceId}}).length == 0) {
    return (
    <div className={css(styles.overlay)}>
      <div className={css(styles.overlayContent)}>
        <p style={{fontSize: '18pt', fontWeight: '550', textAlign: "center"}}> Attention!</p>
        <p style={{color: '#000', fontWeight: '400'}}> Filter contains no devices</p>
        <div className={css(styles.overlayButton)}  style={{color: 'rgb(75, 110, 153)'}} onClick={() => handleCancel()}>Ok</div>
      </div>
    </div>)
  } else if (thisDevices[0].deviceType == 'sensor') {
    return (
    <div className={css(styles.overlay)}>
      <div className={css(styles.overlayContent)}>
        <p style={{fontSize: '18pt', fontWeight: '550'}}> Attention!</p>
        <p style={{color: '#000', fontWeight: '400'}}> Can not reboot sensors</p>
        <div className={css(styles.overlayButton)}  style={{color: 'rgb(75, 110, 153)'}} onClick={() => handleCancel()}>Ok</div>
      </div>
    </div>)
  } else {
    return (
    <div className={css(styles.overlay)}>
      <div className={css(styles.overlayContent)}>
        <p style={{fontSize: '18pt', fontWeight: '550'}}> Attention!</p>
        <p style={{color: '#000', fontWeight: '400'}}> This command will reboot {thisDevices.filter(d => d.resourceId).map(d => {return {resourceId: d.resourceId}}).length} devices </p>
        <div className={css(styles.overlayButton)} onClick={() => handleCancel()}>Cancel</div>
        <div className={css(styles.overlayButton)}  style={{color: 'rgb(75, 110, 153)'}} onClick={() => handleConfirm()}>Confirm</div>
      </div>
    </div>)
  }
}//

function ConfirmOverlay(props) {
  const {infoText, handleCancel, handleConfirm} = props;

  return (
  <div className={css(styles.overlay)}>
    <div className={css(styles.overlayContent)}>
      <p style={{fontSize: '18pt', fontWeight: '550', textAlign: 'center'}}> Attention!</p>
      {infoText.split("\n").map((l) => <p style={{color: '#000', fontWeight: '400'}}>{l}</p>)}
      <div className={css(styles.overlayButton)} onClick={() => {handleCancel()}}>Cancel</div>
      <div className={css(styles.overlayButton)}  style={{color: 'rgb(75, 110, 153)'}} onClick={() => {handleConfirm()}}>Confirm</div>
    </div>
  </div>)
}//

function SnoozeOverlay(props) {
  const {devices, token, user, domain, comment, snoozeUntil, handleClose} = props
  const [thisUser, setThisUser] = useState(user)
  const [domainId, setDomainId] = useState(domain)
  const [thisDevices, setThisDevices] = useState(devices)
  const [thisComment, setThisComment] = useState(comment)
  const [thisSnoozeUntil, setThisSnoozeUntil] = useState(snoozeUntil)
  const [accessToken, setToken] = useState(token)

  function handleCancel() {
    handleClose()
  }

  async function handleConfirm() {
    fetch(
    `${config.API_URL}/healthstatuses`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        resourceIds: thisDevices.filter(d => d.resourceId).map(d => {return {resourceId: d.resourceId}}),
        resourceType: thisDevices[0].resourceType,
        domainId: domainId,
        comment: thisComment,
        snoozeUntil: thisSnoozeUntil.toISOString(),
        author: thisUser.get("fullname")
      }),
      method: 'POST',
    },
    )
    .catch((error) => {
      console.log(error);
    })
    handleClose()
  }

  if (!thisDevices || thisDevices.filter(d => d.resourceId).map(d => {return {resourceId: d.resourceId}}).length == 0) {
    return (
    <div className={css(styles.overlay)}>
      <div className={css(styles.overlayContent)}>
        <p style={{fontSize: '18pt', fontWeight: '550'}}> Attention!</p>
        <p style={{color: '#000', fontWeight: '400'}}> Filter contains no devices</p>
        <div className={css(styles.overlayButton)}  style={{color: 'rgb(75, 110, 153)'}} onClick={() => handleCancel()}>Ok</div>
      </div>
    </div>)
  } else {
    return (
    <div className={css(styles.overlay)}>
      <div className={css(styles.overlayContent)}>
        <p style={{fontSize: '18pt', fontWeight: '550'}}> Attention!</p>
        <p style={{color: '#000', fontWeight: '400'}}> This command will snooze {thisDevices.filter(d => d.resourceId).map(d => {return {resourceId: d.resourceId}}).length} devices </p>
        <div className={css(styles.overlayButton)} onClick={() => handleCancel()}>Cancel</div>
        <div className={css(styles.overlayButton)}  style={{color: 'rgb(75, 110, 153)'}} onClick={() => handleConfirm()}>Confirm</div>
      </div>
    </div>)
  }
}//

function DeviceConfigComponent(props) {
  const {flattenedConfig, editable} = props
  let changes = {}

  return (<div className={css(styles2.deviceJson)}>
    {flattenedConfig.map( (l) => {
      const [name] = l[0].split('.').slice(-1)
      return (<div style={{paddingLeft: (l[0].split('.').length - 1) * 40}}> <div className={css(styles.deviceConfigKey)} style={{display: 'inline'}}> {name + ':'}</div>
        <div className={css(styles.deviceConfigValue)} contenteditable={(editable && l.length > 1) ? "true" : "false"} style={{display: 'inline'}} id={l[0]}>{l[1]}</div>
        </div>)
    })}
    </div>)
}//




function AdminDevicePage(props) {
  const {device, token, user, domain, handleDeviceSelect} = props
  const [thisUser, setThisUser] = useState(user)
  const [domainId, setDomainId] = useState(domain)
  const [thisDevice, setThisDevice] = useState(device)
  const [hasChanges, setHasChanges] = useState(false)
  const [accessToken, setToken] = useState(token)
  const [startDate, setStartDate] = useState(thisDevice.snoozeUntil ? Date.parse(device.snoozeUntil) : Date.now());
  const [confirmOverlayComponent, setConfirmOverlayComponent] = useState('');

  const flattenedConfig = flattenJson(device.deviceConfig, [], '')
  const [configComponent, setConfigComponent] = useState(<DeviceConfigComponent flattenedConfig={flattenedConfig} editable={false}/>)

  function getConfigDiff() {
    var changes = {}
    var elements = document.getElementsByClassName(css(styles.deviceConfigValue))
    for (var i = 0; i < elements.length; i++) {
      var content = elements[i].textContent
      if (content != '' && content != flattenedConfig[i][1]) {
        var path = elements[i].id.split('.')
        var data = changes
        for (var k = 0; k < path.length - 1; k++) {
          if (!data[path[k]]) {
            data[path[k]] = {}
          }
          data = data[path[k]]
        }
        if (content[0] == '[') {
          content = content.replace('[', '').replace(']', '').split(',')
          data[path[path.length -1]] = '[\\'  + content.join('\\,\\') + '\\]'
        } else if (getType('content') == 'string') {
          data[path[path.length -1]] = '\\'  + content + '\\'
        } else {
          data[path[path.length -1]] = content
        }
      }
    }
    return changes
  }  

  function hideOverlay() {
     setConfirmOverlayComponent('')
  }

  function configHideOverlay() {
    setConfirmOverlayComponent('')
    setConfigComponent(<DeviceConfigComponent flattenedConfig={flattenedConfig} editable={false}/>)
    document.getElementById("saveButton").hidden = true;
    document.getElementById("editButton").hidden = false;
    hideOverlay()
  }

  function showOverlay(infoText, handleConfirm, handleCancel) {
    setConfirmOverlayComponent(<ConfirmOverlay infoText={infoText} handleCancel={handleCancel} handleConfirm={handleConfirm}/>)
  }

  function reboot() {
    handleReboot(accessToken, thisDevice.id)
    hideOverlay()
  }

  function deleteDevice() {
    handleDeleteConfig(accessToken, thisDevice.id)
    handleUnassign(accessToken, thisDevice.id)
    handleDeviceSelect({})
    hideOverlay()
  }

  function onEditClicked() {
    setConfigComponent(<DeviceConfigComponent flattenedConfig={flattenedConfig} editable={true}/>)
    document.getElementById("saveButton").hidden = false;
    document.getElementById("editButton").hidden = true;
  }

  function getType(p) {
    if (Array.isArray(p)) return 'array';
    else if (typeof p == 'string') return 'string';
    else if (p != null && typeof p == 'object') return 'object';
    else return 'other';
  }

  function flattenJson(json, result, keyPrefix) {
    for (var key in json) {
        if (json.hasOwnProperty(key)) {
            if (['building', 'floor', 'room', 'seat'].indexOf(key) >= 0){
              result.push([keyPrefix + key + 'Id', json[key].id])
            } else if (getType(json[key]) === 'object') {
              result.push([keyPrefix + key])
              flattenJson(json[key], result, key + '.')
            } else if (getType(json[key]) === 'array') {
              result.push([keyPrefix + key, "[" + json[key].join(',') + "]"])
            } else {
              result.push([keyPrefix + key, json[key]])
            }
        }
      }
    return result
  }
 
  const setSnoozeDate = (snoozeDate) => {
    document.getElementsByClassName("react-datepicker-popper")[0].hidden = true;
    return fetch(
    `${config.API_URL}/healthstatuses`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        resourceId: thisDevice.resourceId,
        resourceType: thisDevice.resourceType,
        domainId: domainId,
        snoozeUntil: snoozeDate.toISOString(),
        author: thisUser.get("fullname")
      }),
      method: 'POST',
    },
    )
    .then(() => {
      thisDevice.snoozed = true
      thisDevice.snoozeUntil = snoozeDate.toISOString()
      setThisDevice(thisDevice)
    })
    .catch((error) => {
      console.log(error);
    })
  }

  const setComment = () => {
    var commentDiv = document.getElementById("editCommentArea");
    var commentText = document.getElementById("commentText");
    commentDiv.style.display = "none";
    return fetch(
    `${config.API_URL}/healthstatuses`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        resourceId: thisDevice.resourceId,
        resourceType: thisDevice.resourceType,
        domainId: domainId,
        comment: commentText.textContent,
        author: thisUser.get("fullname")
      }),
      method: 'POST',
    },
    )
    .then(() => {
      thisDevice.comment = commentText.textContent
      setThisDevice(thisDevice)
    })
    .catch((error) => {
      console.log(error);
    })
  }

  const saveConfig = () => {
    let changes = getConfigDiff()
    setConfigComponent(<DeviceConfigComponent flattenedConfig={flattenedConfig} editable={false}/>)
    document.getElementById("saveButton").hidden = true;
    document.getElementById("editButton").hidden = false;
    hideOverlay()
    handleUpdateDevice(accessToken, thisDevice.id, changes)
  };
  

  const ExampleCustomInput = React.forwardRef(
    ({ value, onClick }, ref) => (
      <div style={{float:'left'}} className={css(styles.deviceStatusButton)} onClick={onClick}>
        Snooze
      </div>
    ),
  );//

  useEffect(() => {
    setThisDevice(props.device)
    setToken(props.token)
  }, [props.device])

  return (
    <div className={css(styles2.deviceContainer)}>
      <div style={{background: '#fff', border: '1px solid #ddd', marginTop: '20px'}}>
        <li key={thisDevice.id} className={css(styles.listItem)} style={{borderBottom: '1px solid rgba(0,0,0,0.0)'}}>
          <div className={css(styles.statusListContent)}>
            <div className={css(styles.box)} style={{background: statusColors[thisDevice.status + 2]}}></div>
            <h4 className={css(styles.listItemContentH4)} >{uppercasefirst(thisDevice.statusText)}</h4>
            <p className={css(styles.listItemContentP)} >{thisDevice.lastSeen}</p>
          </div>
          <div className={css(styles.listItemContent)}>
            <h4 className={css(styles.listItemContentH4)} >{thisDevice.location}</h4>
            <p className={css(styles.listItemContentP)} >{thisDevice.description}</p>
            {thisDevice.resourceType == 'Floorplan' && thisDevice.deviceConfig && thisDevice.deviceConfig.floorplanUrl ? <a target="_blank" rel="noopener noreferrer" href={thisDevice.deviceConfig.floorplanUrl.replace("&d=live", "")}>{thisDevice.deviceConfig.floorplanUrl.split('id=')[1].split('&')[0]}</a> : <p className={css(styles.listItemContentP)} >{thisDevice.id}</p>}
          </div>
          <div className={css(styles.listItemContent)}>
            <h4 className={css(styles.listItemContentH4)} >{thisDevice.snoozed ? "Snoozed until " + thisDevice.snoozeUntil : ""}</h4>
            <p className={css(styles.listItemContentP)} >{thisDevice.comment}</p>
          </div>
        </li>
        </div>
      {configComponent}
      <div onClick={() => handleDeviceSelect({})} style={{position: 'absolute', top: 10, right: 10, cursor: 'pointer'}}>X</div>
      <div className={css(styles.deviceActionBar)}>
        <div className={css(styles.deviceStatusButton)} onClick={() => {
          var commentDiv = document.getElementById("editCommentArea");
          var commentText = document.getElementById("commentText");
          if (!commentDiv.style.display || commentDiv.style.display === "none") {
            commentDiv.style.display = "block";
            placeCaretAtEnd(commentText)
          } else {
            commentDiv.style.display = "none";
          }
        }}>Comment</div>
        <DatePicker onChange={date => setStartDate(date)} showPopperArrow={false} shouldCloseOnSelect={false} minDate={Date.now()} selected={startDate} customInput={<ExampleCustomInput/>} wrapperClassName={css(styles.leftButton)}>  
          <div className={css(styles.confirmButton)} onClick={() => setSnoozeDate(startDate)}>Confirm</div>
        </DatePicker>
        <div className={css(styles.deviceStatusButton)} style={{float:'left'}} id={"editButton"} onClick={() =>onEditClicked()}>Edit</div>
        <div className={css(styles.deviceRebootButton)} onClick={() => showOverlay("This will remove the device from the nimway system. Delete device?", deleteDevice, hideOverlay)}>Delete</div>
        <div className={css(styles.deviceRebootButton)} onClick={() => showOverlay("This will send a reboot action to the device, which could take a few minutes to complete. Reboot device?", reboot, hideOverlay)}>Reboot</div>
        <div className={css(styles.deviceRebootButton)} id={"saveButton"} hidden="true" onClick={() => showOverlay(`This will update the following fields of the device config.\n ${JSON.stringify(getConfigDiff(),null, 2).replaceAll('\\', '')} \n Save config?`, saveConfig, configHideOverlay)}>Save</div>
      </div>
      <div className={css(styles.editCommentArea)} id={"editCommentArea"}>
        <div contenteditable="true" className={css(styles.editCommentText)} id={"commentText"}> {thisDevice.comment ? thisDevice.comment : "Enter comment here..."}</div>
        <div className={css(styles.editConfirmButton)} onClick={() => setComment()}>Confirm</div>
      </div>
      {confirmOverlayComponent}
    </div>
  )//
}

const PAGE_SIZE = 50
const searchPlaceholder = 'Search for build, floor, room, status or name\/description'

function AdminDevicesList(props) {
  let urlParams = new URLSearchParams(window.location.search)
  const {domainIds, accessToken, user} = props
  const decodedJWT = jwtDecode(accessToken)
  const readAccess = decodedJWT.scopes.includes('devices:read')
  const writeAccess = decodedJWT.scopes.includes('devices:write')
  const [thisUser, setThisUser] = useState(user)

  const [page, setPage] = useState(1)
  const [selectedDomain, setSelectedDomain] = useState(urlParams.get("domainId") ? urlParams.get("domainId") : decodedJWT.domainIds[0])
  const [selectedType, setSelectedType]= useState(urlParams.get("deviceType") ? urlParams.get("deviceType"): 'Edge')
  const [searchString, setSearchString] = useState(urlParams.get("searchString") ? urlParams.get("searchString"): searchPlaceholder)
  const [isLoadingDevicesList, setIsLoadingDevicesList] = useState(false)
  const [token, setToken] = useState(accessToken)
  const [startDate, setStartDate] = useState(Date.now());

  const ExampleCustomInput = React.forwardRef(
    ({ value, onClick }, ref) => (
      <div className={css(styles.deviceExportButton)} onClick={onClick}>
        Snooze All
      </div>
    ),
  );//

  function mergeDeviceStatus(devices, statuses, deviceType) {
    statuses = statuses.reduce(function(map, obj) {
      if (deviceType == 'Floorplan') {
        if (obj.resourceId) {
          map[obj.resourceId] = obj;
        }
      } else {
        if (obj.deviceId) {
          map[obj.deviceId] = obj;
        } else if (obj.resourceId){
          map[obj.resourceId] = obj;
        }
      }
      return map;
    }, {});
    devices = devices.map(d => {
      if (deviceType == 'Floorplan') {
        if (d.deviceConfig && d.deviceConfig.floorplanUrl) {
          let key = d.deviceConfig.floorplanUrl.split('id=')[1].split('&')[0];
          if (key in statuses) {
            d.snoozed = Date.parse(statuses[key].snoozeUntil) > Date.now()
            d.snoozeUntil = Date.parse(statuses[key].snoozeUntil)
            d.statusText = d.snoozed ? 'snoozed' : statuses[key].status
            if (d.snoozed) {
              d.status = -2
            } else if (statuses[key] && statuses[key].combinedStatus) {
              d.status = statuses[key].combinedStatus
            } else {
              d.status = 2
            }
            d.statusText = d.status == 1 ? 'unconfigured': d.statusText 
            d.comment = statuses[key].comment
            d.lastSeen = statuses[key].lastUpdatedAt.substring(0, statuses[key].lastUpdatedAt.lastIndexOf(":"));
            d.resourceId = statuses[key].resourceId
            d.resourceType = statuses[key].resourceType
          }
        }
      } else {
        var key
        if (d.id in statuses) {
          key = d.id
        } else if (d.hardwareId in statuses) {
          key = d.hardwareId
        }
        if (key) {
          d.snoozed = Date.parse(statuses[key].snoozeUntil) > Date.now()
          d.snoozeUntil = statuses[key].snoozeUntil
          d.statusText = d.snoozed ? 'snoozed' : statuses[key].status
          if (d.snoozed) {
            d.status = -2
          } else if (statuses[key] && statuses[key].combinedStatus) {
            d.status = statuses[key].combinedStatus
          } else {
            d.status = 2
          }
          d.statusText = d.status == 1 ? 'unconfigured': d.statusText 
          d.comment = statuses[key].comment
          d.lastSeen = statuses[key].lastUpdatedAt.substring(0, statuses[key].lastUpdatedAt.lastIndexOf(":"));
          d.resourceId = statuses[key].resourceId
          d.resourceType = statuses[key].resourceType
        }
      }
      return d
    })
    return devices
  }

  async function loadDevicesList() {
    setIsLoadingDevicesList(true)
    let [deviceListResponse, deviceStatusRespons] = await Promise.all([fetchDevicesList(token, selectedDomain, selectedType), fetchDeviceStatusMap(token, selectedDomain, selectedType)]) 
    deviceListResponse = mergeDeviceStatus(deviceListResponse, deviceStatusRespons, selectedType)
    deviceListResponse.message || setDevicesList(sortBy(deviceListResponse, 'email'))
    setIsLoadingDevicesList(false)
  }

  async function rebootDevices(accessToken, devices) {
    await Promise.all(devices.map(d => handleReboot(accessToken, d.id)))
  }

  function handleExport(devices, deviceType) {
    var exportString
    if (deviceType == 'Edge' || deviceType == 'Floorplan') {
      exportString = 'id,lastSeen,building id,building name,floor id,floor name'
    } else if (deviceType == 'Tablet') {
      exportString = 'id,lastSeen,hardwareId,building id,building name, floor id, floor name,room name'
    } else if (deviceType == 'Sensor') {
      exportString = 'id,lastSeen,mac address,building id,building name, floor id, floor name, room/desk, resourceId'
    } else if (deviceType == 'Beacon') {
      exportString = 'id,lastSeen,mac address,building id,building name, floor id, floor name,x,y'
    } 
    for (var i in devices) {
      var d = devices[i]
      if (!d.deviceConfig || !d.deviceConfig.building || !d.deviceConfig.floor) {
        continue
      }
      exportString += '\n' 
      if (d.deviceType == 'floorplan') {
        exportString += d.id + ','  + d.lastSeen + ',' + d.deviceConfig.building.id + ',' + d.deviceConfig.building.name + ',' + d.deviceConfig.floor.id + ',' + d.deviceConfig.floor.name
      } else if (d.deviceType == 'tablet') {
        exportString += d.id + ','  + d.lastSeen + ',' + d.hardwareId + ',' + d.deviceConfig.building.id + ',' + d.deviceConfig.building.name + ',' + d.deviceConfig.floor.id + ',' + d.deviceConfig.floor.name + ',' + d.deviceConfig.tabletConfig.room.name
      } else if (d.deviceType == 'sensor') {
        if (d.deviceConfig && d.deviceConfig.sensorConfig && d.deviceConfig.sensorConfig.type) {
          exportString +=  d.id + ','  + d.lastSeen + ',' + d.hardwareId + ',' + d.deviceConfig.sensorConfig.type + ',' + d.deviceConfig.building.id + ',' + d.deviceConfig.building.name + ',' + d.deviceConfig.floor.id + ',' + d.deviceConfig.floor.name
          if (d.deviceConfig.sensorConfig.room && d.deviceConfig.sensorConfig.room.name) {
            exportString += "," + d.deviceConfig.sensorConfig.room.name + ',' + d.deviceConfig.sensorConfig.room.id
          } else if (d.deviceConfig.sensorConfig.seat && d.deviceConfig.sensorConfig.seat.name) {
            exportString += "," + d.deviceConfig.sensorConfig.seat.name + ',' + d.deviceConfig.sensorConfig.seat.id
          } else if (d.deviceConfig.sensorConfig.seat && d.deviceConfig.sensorConfig.seat.internalId) {
            exportString += "," + d.deviceConfig.sensorConfig.seat.internalId + ',' + d.deviceConfig.sensorConfig.seat.id
          } else if (d.deviceConfig.sensorConfig.room) {
            exportString += "," + d.deviceConfig.sensorConfig.room.id
          } else if (d.deviceConfig.sensorConfig.seat) {
            exportString += "," + d.deviceConfig.sensorConfig.seat.id
          } else {
            exportString += ","
          }
        }
      } else if (d.deviceType == 'beacon') {
        if (d.deviceConfig && d.deviceConfig.beaconConfig && d.deviceConfig.beaconConfig.macAddress && d.deviceConfig.beaconConfig.macAddress != 'NULL') {
          exportString +=  d.id + ','  + d.lastSeen + ',' + d.deviceConfig.beaconConfig.macAddress + ',' + d.deviceConfig.building.id + ',' + d.deviceConfig.building.name + ',' + d.deviceConfig.floor.id + ',' + d.deviceConfig.floor.name + ',' + d.deviceConfig.beaconConfig.x + ',' + d.deviceConfig.beaconConfig.y
        }
      }
    }
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(exportString));
    element.setAttribute('download', deviceType + '_export' + ".csv");

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  function getKibanaLinkForSelection(){
    if (!searchString || searchString == '' || searchString == searchPlaceholder) {
      if (selectedType == 'Edge') {
        return `https://kibana.nimway.com/_plugin/kibana/app/kibana#/discover?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-10d,to:now))&_a=(columns:!(_source),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'7d5ace50-76fc-11e9-9822-238eecd2dbca',key:data.live,negate:!t,params:(query:false),type:phrase,value:false),query:(match:(data.live:(query:false,type:phrase))))),index:'7d5ace50-76fc-11e9-9822-238eecd2dbca',interval:auto,query:(language:kuery,query:'domainId:!'${selectedDomain}!'%20and%20type:%22!'edgeHealth!'%22'),sort:!(!(timestamp,desc)))`
      } else if (selectedType == 'Tablet') {
        return `https://kibana.nimway.com/_plugin/kibana/app/kibana#/discover?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-10d,to:now))&_a=(columns:!(_source),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'7d5ace50-76fc-11e9-9822-238eecd2dbca',key:data.live,negate:!t,params:(query:false),type:phrase,value:false),query:(match:(data.live:(query:false,type:phrase))))),index:'7d5ace50-76fc-11e9-9822-238eecd2dbca',interval:auto,query:(language:kuery,query:'domainId:!'${selectedDomain}!'%20and%20type:%22!'tabletHealth!'%22'),sort:!(!(timestamp,desc)))`
      } else if (selectedType == 'Floorplan') {
        return `https://kibana.nimway.com/_plugin/kibana/app/kibana#/discover?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-10d,to:now))&_a=(columns:!(_source),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'7d5ace50-76fc-11e9-9822-238eecd2dbca',key:data.live,negate:!t,params:(query:false),type:phrase,value:false),query:(match:(data.live:(query:false,type:phrase))))),index:'7d5ace50-76fc-11e9-9822-238eecd2dbca',interval:auto,query:(language:kuery,query:'domainId:!'${selectedDomain}!'%20and%20type:%22!'floorplanHealth!'%22'),sort:!(!(timestamp,desc)))`
      } else if (selectedType == 'Sensor') {
        return `https://kibana.nimway.com/_plugin/kibana/app/kibana#/discover?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-10d,to:now))&_a=(columns:!(_source),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'7d5ace50-76fc-11e9-9822-238eecd2dbca',key:data.live,negate:!t,params:(query:false),type:phrase,value:false),query:(match:(data.live:(query:false,type:phrase))))),index:'7d5ace50-76fc-11e9-9822-238eecd2dbca',interval:auto,query:(language:kuery,query:'domainId:!'${selectedDomain}!'%20and%20eventType:%22!'nimwaySensor!'%22'),sort:!(!(timestamp,desc)))`
      }
    } else {
      if (selectedType == 'Edge' || selectedType == 'Tablet') {
        let ids = ''
        let values = ''
        let matcher = ''
        for (var i = 0; i < devicesListFitleredBySearchString.length; i++) {
          if (i> 0) {
            ids += ','
            matcher += ','
            values += ','
          }
          matcher += `(match_phrase:(clientId:'${devicesListFitleredBySearchString[i].id}'))`
          ids += `'${devicesListFitleredBySearchString[i].id}'`
          values += `${devicesListFitleredBySearchString[i].id}`
        }
        return `https://kibana.nimway.com/_plugin/kibana/app/kibana#/discover?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-10d,to:now))&_a=(columns:!(_source),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'7d5ace50-76fc-11e9-9822-238eecd2dbca',key:clientId,negate:!f,params:!(${ids}),type:phrases,value:'${values}'),query:(bool:(minimum_should_match:1,should:!(${matcher}))))),index:'7d5ace50-76fc-11e9-9822-238eecd2dbca',interval:auto,query:(language:kuery,query:''),sort:!(!(timestamp,desc)))`
      } else if (selectedType == 'Floorplan') {
        let ids = ''
        let values = ''
        let matcher = ''
        for (var i = 0; i < devicesListFitleredBySearchString.length; i++) {
          let id = devicesListFitleredBySearchString[i].deviceConfig.floorplanUrl.split('id=')[1].split('&u')[0]
          if (i> 0) {
            ids += ','
            matcher += ','
            values += ','
          }
          matcher += `(match_phrase:(clientId:'${id}'))`
          ids += `'${id}'`
          values += `${id}`
        }
        return `https://kibana.nimway.com/_plugin/kibana/app/kibana#/discover?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-10d,to:now))&_a=(columns:!(_source),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'7d5ace50-76fc-11e9-9822-238eecd2dbca',key:clientId,negate:!f,params:!(${ids}),type:phrases,value:'${values}'),query:(bool:(minimum_should_match:1,should:!(${matcher}))))),index:'7d5ace50-76fc-11e9-9822-238eecd2dbca',interval:auto,query:(language:kuery,query:''),sort:!(!(timestamp,desc)))`
      } else if (selectedType == 'Sensor') {
        let ids = ''
        let values = ''
        let matcher = ''
        for (var i = 0; i < devicesListFitleredBySearchString.length; i++) {
          if (i> 0) {
            ids += ','
            matcher += ','
            values += ','
          }
          matcher += `(match_phrase:(sensorId:'${devicesListFitleredBySearchString[i].hardwareId}'))`
          ids += `'${devicesListFitleredBySearchString[i].hardwareId}'`
          values += `${devicesListFitleredBySearchString[i].hardwareId}`
        }
        return `https://kibana.nimway.com/_plugin/kibana/app/kibana#/discover?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-10d,to:now))&_a=(columns:!(_source),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'7d5ace50-76fc-11e9-9822-238eecd2dbca',key:sensorId,negate:!f,params:!(${ids}),type:phrases,value:'${values}'),query:(bool:(minimum_should_match:1,should:!(${matcher}))))),index:'7d5ace50-76fc-11e9-9822-238eecd2dbca',interval:auto,query:(language:kuery,query:''),sort:!(!(timestamp,desc)))`
      }
    }
  }

  function handleDeviceSelect(device) {
    setDeviceVisible(device)
    if (JSON.stringify(device) === JSON.stringify({})) {
      loadDevicesList()
    }
  }
  function handleSnoozeClicked(device) {
    setSnoozeClicked(true)
  }
  function handleRebootClicked(device) {
    setRebootClicked(true)
  }
  function handleTokenChange(e) {
    setToken(e.currentTarget.value)
  }
  function handleSearch(e) {
    urlParams.set('searchString', e.currentTarget.value)
    window.history.replaceState({}, '', `${location.pathname}?${urlParams}`);
    setSearchString(e.currentTarget.value)
  }
  function handleSearchFocus(e) {
    if (searchString === searchPlaceholder) {
      setSearchString('')
    }
  }
  function handleSearchBlur(e) {
    if (e.currentTarget.value === '') {
      setSearchString(searchPlaceholder)
    }
  }
  function handleDomainSelection(domainId) {
    urlParams.set('domainId', domainId)
    window.history.replaceState({}, '', `${location.pathname}?${urlParams}`);
    setSelectedDomain(domainId)
    setPage(1)
  }
  function handleTypeSelection(type) {
    urlParams.set('deviceType', type)
    window.history.replaceState({}, '', `${location.pathname}?${urlParams}`);
    setSelectedType(type)
    setPage(1)
  }
  function handlePageChange(newPage) {
    setPage(newPage)
  }

  function getStatusColor(code) {
    return '#fff'
  }

  function deviceSearch(device, searchString) {
    searchString = searchString.toLowerCase()
    let parts = searchString.split('+')
    let matched = false
    for (var i = 0; i < parts.length; i++) {
      matched = false
      try {
        if ((device.name && device.name.toLowerCase().includes(parts[i])) || (device.description && device.description.toLowerCase().includes(parts[i]))) {
          matched = true
        }
        if (!device.deviceConfig && !matched) {
          return false
        }
        if (device.deviceConfig.floor && device.deviceConfig.floor.id && device.deviceConfig.floor.id == parts[i]) {
          matched = true
        }

        if (device.deviceConfig.building && device.deviceConfig.building.id && device.deviceConfig.building.id == parts[i]) {
          matched = true
        }
        if (device.location.toLowerCase().includes(parts[i])) {
          matched = true
        }
        if (device.statusText && device.statusText.toLowerCase().includes(parts[i])) {
          matched = true
        }
        if (device.resourceType == 'sensor' && device.deviceConfig.sensorConfig && device.deviceConfig.sensorConfig.address.includes(parts[i])) {
          matched = true
        }
        if (device.resourceType == 'sensor' && device.deviceConfig.sensorConfig && device.deviceConfig.sensorConfig.edgeId.includes(parts[i])) {
          matched = true
        }
        if (parts[i] == 'notok' && ['error', 'warning', 'missing', 'snoozed', 'unconfigured'].indexOf(device.statusText) >= 0) {
          matched = true
        }
      } catch (error) {
        console.log(error);
        return false
      }
      if (!matched) {
        return false
      }
    }
    return true
  }

  function handleSnoozeClose() {
    setSnoozeClicked(false)
    loadDevicesList()
  }

  function handleRebootClose() {
    setRebootClicked(false)
  }

  function handleKibanaClicked() {
    let kibanaUrl = getKibanaLinkForSelection();
    window.open(kibanaUrl, '_blank')
  }

  function getKibanaLink(device) {
    if (device.resourceType == 'edge' || device.resourceType == 'tablet') {
      return `https://kibana.nimway.com/_plugin/kibana/app/kibana#/discover?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-10d,to:now))&_a=(columns:!(_source),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'7d5ace50-76fc-11e9-9822-238eecd2dbca',key:data.live,negate:!t,params:(query:false),type:phrase,value:false),query:(match:(data.live:(query:false,type:phrase))))),index:'7d5ace50-76fc-11e9-9822-238eecd2dbca',interval:auto,query:(language:kuery,query:'clientId:%22${device.id}%22'),sort:!(!(timestamp,desc)))`
    } else if (device.deviceType == 'floorplan' && device.deviceConfig && device.deviceConfig.floorplanUrl && device.deviceConfig.floorplanUrl.includes('&id')) {
      let id = device.deviceConfig.floorplanUrl.split('id=')[1].split('&u')[0]
      return `https://kibana.nimway.com/_plugin/kibana/app/kibana#/discover?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-10d,to:now))&_a=(columns:!(_source),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'7d5ace50-76fc-11e9-9822-238eecd2dbca',key:data.live,negate:!t,params:(query:false),type:phrase,value:false),query:(match:(data.live:(query:false,type:phrase))))),index:'7d5ace50-76fc-11e9-9822-238eecd2dbca',interval:auto,query:(language:kuery,query:'clientId:%22${id}%22'),sort:!(!(timestamp,desc)))`
    } else if (device.deviceType == 'sensor' && device.hardwareId) {
      return `https://kibana.nimway.com/_plugin/kibana/app/kibana#/discover?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-10d,to:now))&_a=(columns:!(_source),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'7d5ace50-76fc-11e9-9822-238eecd2dbca',key:data.live,negate:!t,params:(query:false),type:phrase,value:false),query:(match:(data.live:(query:false,type:phrase))))),index:'7d5ace50-76fc-11e9-9822-238eecd2dbca',interval:auto,query:(language:kuery,query:'sensorId:%22${device.hardwareId}%22'),sort:!(!(timestamp,desc)))`
    }

  }

  useEffect(() => {
    setDevicesList([])
    loadDevicesList()
  }, [token, selectedDomain])

  useEffect(() => {
    setDevicesList([])
    loadDevicesList()
  }, [token, selectedType])

  useEffect(() => {
    setToken(props.accessToken)
  }, [props.accessToken])

  const [devicesList, setDevicesList] = useState([])
  const [deviceVisible, setDeviceVisible] = useState({})
  const [snoozeClicked, setSnoozeClicked] = useState((false))
  const [rebootClicked, setRebootClicked] = useState((false))

  const devicesListFitleredBySearchString = searchString !== searchPlaceholder ? devicesList.filter((d) => deviceSearch(d, searchString)) : devicesList

  const pageCount = Math.ceil(devicesListFitleredBySearchString.length / PAGE_SIZE)
  const pageStart = (page - 1) * PAGE_SIZE
  const pageEnd = page * PAGE_SIZE
  const pageArray = createArray(pageCount)

  const pagedDevicesList = devicesListFitleredBySearchString.slice(pageStart, pageEnd)

  let snoozeOverlayComponent = ''

  if (snoozeClicked) {
    let commentText = document.getElementById("commentAllText").textContent;
    snoozeOverlayComponent = <SnoozeOverlay devices={devicesListFitleredBySearchString} token={token} user={thisUser} domain={selectedDomain} comment={commentText} snoozeUntil={startDate} handleClose={handleSnoozeClose}/>
  }

  let rebootOverlayComponent = ''
  if (rebootClicked) {
    rebootOverlayComponent = <RebootOverlay devices={devicesListFitleredBySearchString} token={token} handleClose={handleRebootClose}/>
  }

  let selectedDeviceComponent = ''
  if (deviceVisible.id) {
    selectedDeviceComponent = <AdminDevicePage device={deviceVisible} token={token} handleDeviceSelect={handleDeviceSelect} user={thisUser} domain={selectedDomain}/>
  }
  
  const filterComponent = !isLoadingDevicesList ? (
    <>
      <input className={css(styles.tokenInput)} value={searchString} onChange={handleSearch} onFocus={handleSearchFocus} onBlur={handleSearchBlur}/>
    </>
  ) : ''//
  const pageComponent = !isLoadingDevicesList ? (
    <>
      <div className={css(styles.devicesListPager)}>
        <div><div className={css(styles.devicesListPageChanger)} style={page === 1 ? {color: '#ccc', borderColor: '#ccc', cursor: 'default'} : {}} onClick={page === 1 ? noop : () => handlePageChange(page - 1)}>Previous</div></div>
        <div className={css(styles.devicesListPageNumbers)}>
          {pageArray.map(i => {
            return <div className={css(styles.devicesListPageNumber)} style={page === i+1 ? {background: 'rgb(75, 110, 153)', color: '#fff', cursor: 'default'} : {}} onClick={() => handlePageChange(i+1)}>{i+1}</div>
          })}
        </div>
        <div><div className={css(styles.devicesListPageChanger)} style={page === pageCount ? {color: '#ccc', borderColor: '#ccc', cursor: 'default'} : {}} onClick={page === pageCount ? noop : () => handlePageChange(page + 1)}>Next</div></div>
      </div>
      <div className={css(styles.devicesListPageCount)}>
        {`${pageStart + 1} - ${pageEnd <= devicesListFitleredBySearchString.length ? pageEnd : devicesListFitleredBySearchString.length} of ${devicesListFitleredBySearchString.length}`}
      </div>
    </>
  ) : ''//
  return readAccess ? (
    <div>
      <Loading isLoading={isLoadingDevicesList} />
      <div className={css(styles.devicesListContainer)}>
        <div className={css(styles.availableRoles)}>
          {domainIds.map((domanId) => {
            return <div className={css(styles.availableRole)} style={selectedDomain === domanId ? {background: 'rgb(75, 110, 153)', color: '#fff'} : {}} onClick={() => handleDomainSelection(domanId)}>{domanId}</div>
          })}
        </div>
        {filterComponent}
        <div>
        <div className={css(styles.availableRoles)}>
          {['Beacon','Edge','Sensor','Tablet', 'External'].map((type) => {
            return <div className={css(styles.availableRole)} style={selectedType === type ? {background: 'rgb(75, 110, 153)', color: '#fff'} : {}} onClick={() => handleTypeSelection(type)}>{type}</div>
          })}
          <div className={css(styles.devicesActionBar)}>
            <div className={css(styles.deviceExportButton)} onClick={() => handleKibanaClicked()}>Kibana</div>
            <div className={css(styles.deviceExportButton)} onClick={() => handleExport(devicesListFitleredBySearchString, selectedType)}>Export</div>
            <div className={css(styles.deviceExportButton)} onClick={() => handleRebootClicked()}>Reboot All</div>
            <DatePicker style={{float:'right'}} onChange={date => setStartDate(date)} showPopperArrow={false} shouldCloseOnSelect={false} minDate={Date.now()} selected={startDate} customInput={<ExampleCustomInput/>} id={"datePickerAllDevices"} >  
              <div className={css(styles.editCommentAllArea)} >
                <p>Enter comment below:</p>
                <div contenteditable="true" className={css(styles.editCommentAllText)} id={"commentAllText"}> </div>
              </div>
              <div className={css(styles.confirmButton)} onClick={() => handleSnoozeClicked()}>Confirm</div>
            </DatePicker>
          </div>
        </div>
          
        </div>
        {pageComponent}
        <div>
          <ul className={css(styles.list)}>
            {pagedDevicesList.map((d) => {
              return (
                <li key={d.id} className={css(styles.listItem)} onClick={() => handleDeviceSelect(d)}>
                  <div className={css(styles.statusListContent)}>
                    <div className={css(styles.box)} style={{background: statusColors[d.status + 2]}}></div>
                    <h4 className={css(styles.listItemContentH4)} >{uppercasefirst(d.statusText)}</h4>
                    <p className={css(styles.listItemContentP)} >{d.lastSeen}</p>
                  </div>
                  <div className={css(styles.listItemContent)}>
                    <h4 className={css(styles.listItemContentH4)} >{d.location}</h4>
                    <p className={css(styles.listItemContentP)} >{d.description}</p>
                    {selectedType == 'Floorplan' && d.deviceConfig && d.deviceConfig.floorplanUrl ? <a target="_blank" rel="noopener noreferrer" href={d.deviceConfig.floorplanUrl.replace("&d=live", "")}>{d.deviceConfig.floorplanUrl.split('id=')[1].split('&')[0]}</a> : <p className={css(styles.listItemContentP)} >{d.hardwareId ? d.hardwareId : d.id}</p>}
                  </div>
                  <div className={css(styles.listItemContent)}>
                    <h4 className={css(styles.listItemContentH4)} >{d.snoozed ? "Snoozed until " + d.snoozeUntil : ""}</h4>
                    <p className={css(styles.listItemContentP)} >{d.comment}</p>
                  </div>
                  <div className={css(styles.listItemContent)}>
                    <a target="_blank" rel="noopener noreferrer" href={getKibanaLink(d)}>
                      <img src={kibanaImg} className={css(styles.listItemImage)}></img>
                    </a>
                  </div>
                </li>
              )
            })}
          </ul>
        </div>
        {pageComponent}
      </div>
      {snoozeOverlayComponent}
      {rebootOverlayComponent}
      {selectedDeviceComponent}
    </div>
  ) : <div className={css(styles.accessDenied)} >Access Denied, need devices:read scope to list all devices</div>
}

AdminDevicesList.propTypes = {
  accessToken: PropTypes.string.isRequired,
  domainIds: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired
}

const mapStateToProps = (state) => {
  return {
    accessToken: getAccessToken(state),
    user: state.get('user'),
    domainIds: state
      .getIn(['versions', 'all'], _.List())
      .map((versionsData) => {
        return versionsData.get('id')
      })
      .sortBy((id) => id),
  }
}

export default connect(mapStateToProps, {})(AdminDevicesList)
